import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CustomersSection from './components/CustomersSection';
import AboutSection from './components/AboutSection';
import SolutionsSection from './components/SolutionsSection';
import ContactsSection from './components/ContactsSection';
import Footer from './components/Footer';

import './App.css';

const App = () => (
  <div className="app">
    <Header />
    <HeroSection />
    <CustomersSection />
    <AboutSection />
    <SolutionsSection />
    <ContactsSection />
    <Footer />
  </div>
);

export default App;